import SharedMessagesV2 from "@/components/shared/MessagesV2";
export default function DealSourcerMessages() {
  return <SharedMessagesV2 role="seller" />;
}